import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import FieldDropdown from "../../../components/common/InputField/FieldDropdown";
import MainButton from "../../../components/common/MainButton/MainButton";
import Heading from "../../../components/common/Typography/Heading";
import Snippet from "../../../components/common/SnippetIcon/Snippet";
import WrittenStepper from "../../../components/common/StepIndicater/WrittenStepper";
import { UpdateUserMutation } from "../../../services/SignUp";
import { useGraphQL } from "../../../context/GraphQLProvider";
import Alerts from "../../../components/common/Alerts/Alerts";
import Spinner from "../../../components/common/Spinner";
import { fetchServiceCategories } from "../../../Redux/Slice/serviceCategoriesSlice";
import { setField, setStep } from "../../../Redux/Slice/SignUp";
import StepBackButton from "../../../components/common/StepBackButton/StepBackButton";
import { transformToUserInput } from "../../../utils/userInputUtils";
import { POPUP_FORM_CONTENT_CLASS } from "../../../components/popup/popupLayoutSpec";

const SelectService = ({ onClickHandler }) => {
    const graphqlService = useGraphQL();
    const dispatch = useDispatch();
    const [mainCategory, setMainCategory] = useState(null);
    const [requestStart, setRequestStart] = useState(false);
    const InitialValues = useSelector((state) => state.signup);
    const { id, email, serviceCategoryId, step } = useSelector((state) => state.signup);
    const { categories, loading, error } = useSelector((state) => state.serviceCategories);

    useEffect(() => {
        if (categories.length === 0) {
            dispatch(fetchServiceCategories(graphqlService));
        }
    }, [dispatch, graphqlService, categories.length]);

    // When skipping, dummy data sets serviceCategoryId "1" – resolve it to Plumbing so the correct trade is selected
    useEffect(() => {
        if (categories.length === 0 || serviceCategoryId !== "1") return;
        const plumbingCategory = categories.find(c => (c.name || "").trim().toLowerCase() === "plumbing");
        if (plumbingCategory) {
            dispatch(setField({ serviceCategoryId: plumbingCategory.id }));
            setMainCategory(plumbingCategory.id);
        }
    }, [categories, serviceCategoryId, dispatch]);

    useEffect(() => {
        if (categories.length === 0 || serviceCategoryId == null || serviceCategoryId === "") return;
        const selectedCategory = categories.find(category => category.id == serviceCategoryId);
        if (selectedCategory && mainCategory !== selectedCategory.id) {
            setMainCategory(selectedCategory.id);
        }
    }, [categories, serviceCategoryId, mainCategory]);

    const handleSubmit = async () => {
        if (mainCategory == null || mainCategory === "") {
            Alerts.error("Please select a service category");
            return;
        }

        setRequestStart(true);
        const userInput = transformToUserInput(InitialValues);
        userInput.userInput.serviceCategoryId = mainCategory;

        try {
            const response = await UpdateUserMutation(graphqlService, userInput);
            if (response.updateUserProfile?.serviceCategoryId === mainCategory) {
                dispatch(setField({ serviceCategoryId: mainCategory }));
                onClickHandler();
            }
        } catch (error) {
            Alerts.error(error.message);
        } finally {
            setRequestStart(false);
        }
    };

    return (
        <>
            {(loading || requestStart) && <Spinner />}
            <div className="overflow-auto overflow-visible relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
                <div className={POPUP_FORM_CONTENT_CLASS}>
                    <Heading
                        variant={"h6"}
                        className={"flex items-center justify-center text-center text-offblack"}
                    >
                        Trade Category
                    </Heading>
                    <div className="mt-10 xl:mt-[60px] w-full">
                        <div className="flex justify-center w-full">
                            <div className="w-full mx-auto">
                                <div className="flex">
                                    <Snippet
                                        variant={"label"}
                                        snippet={true}
                                        star={true}
                                        text={"Select the main category that best represents your business, for example, carpentry."}
                                        label={"Select your trade category"}
                                    />
                                </div>
                                <div className="mt-2 w-full">
                                    <FieldDropdown
                                        variant="general"
                                        value={mainCategory}
                                        onChange={(e) => {
                                            const id = e.value;
                                            setMainCategory(id);
                                            if (id != null && id !== "") {
                                                dispatch(setField({ serviceCategoryId: id }));
                                            }
                                        }}
                                        options={categories}
                                        optionLabel="name"
                                        optionValue="id"
                                        placeholder="Choose 1 from list"
                                        disabled={loading || categories.length === 0}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-center w-full">
                            <div className="w-full mx-auto">
                                <div className="flex items-center justify-between mt-10 w-full">
                                    <StepBackButton onClick={() => dispatch(setStep(step - 1))} />
                                    <MainButton
                                        variant={"small"}
                                        onClick={handleSubmit}
                                        // disabled={loading || requestStart}
                                    >
                                        Next
                                    </MainButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <WrittenStepper
                currentStep={5}
                lastStep={8}
                currentLabel={"Select your service"}
                marginTop={"absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full"}
            /> */}
        </>
    );
};

export default SelectService; 